'use client';

import React from 'react';
import { useTabContext } from '@/components/context/TabContext';

const CheckList = ({ title, description, classes, iconColor = '#006EB7', descriptionClasses, titleClasses }) => {
  const { selectedTab } = useTabContext();

  return (
    <div className={`flex gap-3 items-start ${classes}`}>
      <div className="mt-1 flex-shrink-0">
        <svg
          width="17"
          height="17"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.6666 5L7.49992 14.1667L3.33325 10"
            stroke={`${selectedTab === 'adviser' ? '#006EB7' : '#8D1558'}`}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div>
        <p className="text-[#373945] text-base">
          <span className={`font-semibold ${titleClasses}`}>{title}</span>{title ? ': ' : ''}
          <span className={`font-450 ${descriptionClasses}`} dangerouslySetInnerHTML={{ __html: description }}></span>
        </p>
      </div>
    </div>
  );
};

export default CheckList;
